// Kabuk (AppShell) erişilebilir adları — Finar UX P2 İ5. Saf yardımcılar: dar ekranda
// profil adı gizlenir (avatar aria-hidden), daraltılmış rail'de bağlantı metni yoktur;
// her iki durumda erişilebilir ad buradan gelir (title'a bırakılmaz).

import { roleDisplayName } from "@mahir/shared";

export function profileButtonLabel(user: { fullName: string; roleName: string }): string {
  return `${user.fullName} · ${roleDisplayName(user.roleName)}`;
}

/** Rail açıkken görünür metin adı verir → aria-label gereksiz (çift okuma olmasın). */
export function railLinkLabel(collapsed: boolean, label: string): string | undefined {
  return collapsed ? label : undefined;
}
